import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

/**
 * Reusable Internal Chat error state with retry (SPEC-2026-07-internal-chat,
 * T-25 · RNF-08).
 *
 * Used wherever a chat read can fail and the user can meaningfully retry
 * (bootstrap snapshot, history page, saved list, search). `retry` must be wired
 * to a handler that RE-DISPATCHES the failing action — never to a reload:
 *
 * ```html
 * <chat-error-state
 *   messageKey="chat.states.loadError"
 *   (retry)="retryBootstrap()"
 * ></chat-error-state>
 * ```
 *
 * Every text input is an i18n key, translated in the template.
 */
@Component({
  selector: 'chat-error-state',
  templateUrl: './chat-error-state.component.html',
  styleUrls: ['./chat-state-panel.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChatErrorStateComponent {

  @Input() icon = 'ri-error-warning-line';

  /** i18n key of the error message. */
  @Input() messageKey = 'chat.states.loadError';

  /** i18n key of an optional second line. */
  @Input() hintKey: string | null = 'chat.states.loadErrorHint';

  /** i18n key of the retry button. */
  @Input() retryKey = 'chat.states.retry';

  /** Tighter spacing/typography for the bubble popup surface. */
  @Input() compact = false;

  @Output() retry = new EventEmitter<void>();
}
